import { useHistory } from "react-router-dom";
import AdminLogin from "views/admin/AdminLogin";
import Login from "views/Login";

/**
 * Redirect to the desired base login page depending on where the user was at 
 * when they were logged out or the page that they were requesting.
 *
 * @return {ReactComponentElement}
 */
const logoutRedirect = () => {
  const history = useHistory();

  const basePath = history.location.pathname.split("/")[1];

  switch (basePath) {
    case "admin":
      history.push({ pathname: "/admin/login" });
      return <AdminLogin />;
    default:
      history.push({ pathname: "/login" });
      return <Login />;
  }
};

export default logoutRedirect;